export default {
    topics: [
        {
            title: ' loadString ',
            href: 'f-loadString.html',
            attributes: { 'data-id': 'f-loadString' },
            menu: { hasChildren: false },
            tocID: 'f-loadString-d66e4453',
            topics: [],
        },
        {
            title: ' saveString ',
            href: 'f-saveString.html',
            attributes: { 'data-id': 'f-saveString' },
            menu: { hasChildren: false },
            tocID: 'f-saveString-d66e4461',
            topics: [],
        },
        {
            title: ' saveXmlString ',
            href: 'f-saveXmlString.html',
            attributes: { 'data-id': 'f-saveXmlString' },
            menu: { hasChildren: false },
            tocID: 'f-saveXmlString-d66e4469',
            topics: [],
        },
        {
            title: ' loadFile ',
            href: 'f-loadFile.html',
            attributes: { 'data-id': 'f-loadFile' },
            menu: { hasChildren: false },
            tocID: 'f-loadFile-d66e4477',
            topics: [],
        },
        {
            title: ' loadXmlFile ',
            href: 'f-loadXmlFile.html',
            attributes: { 'data-id': 'f-loadXmlFile' },
            menu: { hasChildren: false },
            tocID: 'f-loadXmlFile-d66e4485',
            topics: [],
        },
        {
            title: ' saveFile ',
            href: 'f-saveFile.html',
            attributes: { 'data-id': 'f-saveFile' },
            menu: { hasChildren: false },
            tocID: 'f-saveFile-d66e4493',
            topics: [],
        },
        {
            title: ' saveXmlFile ',
            href: 'f-saveXmlFile.html',
            attributes: { 'data-id': 'f-saveXmlFile' },
            menu: { hasChildren: false },
            tocID: 'f-saveXmlFile-d66e4501',
            topics: [],
        },
        {
            title: ' fileRename ',
            href: 'f-fileRename.html',
            attributes: { 'data-id': 'f-fileRename' },
            menu: { hasChildren: false },
            tocID: 'f-fileRename-d66e4509',
            topics: [],
        },
        {
            title: ' fileGetTempName ',
            href: 'f-fileGetTempName.html',
            attributes: { 'data-id': 'f-fileGetTempName' },
            menu: { hasChildren: false },
            tocID: 'f-fileGetTempName-d66e4517',
            topics: [],
        },
        {
            title: ' fileIsRelative ',
            href: 'f-fileIsRelative.html',
            attributes: { 'data-id': 'f-fileIsRelative' },
            menu: { hasChildren: false },
            tocID: 'f-fileIsRelative-d66e4525',
            topics: [],
        },
        {
            title: ' fileSize ',
            href: 'f-fileSize.html',
            attributes: { 'data-id': 'f-fileSize' },
            menu: { hasChildren: false },
            tocID: 'f-fileSize-d66e4533',
            topics: [],
        },
    ],
};

